import React from 'react';
import { prettyNumber } from '../../../utils/helpers';
import { InfoViewsContainer, InfoViewsText } from './styled';
import Icon from '../../Icon';
import ViewsIcon from '../../../public/static/images/residences/views.svg';

interface InfoViewsProps {
  hits?: number | null;
}

export const InfoViews: React.FC<InfoViewsProps> = ({ hits }) => {
  const prettyViews = prettyNumber(hits);

  return (
    <InfoViewsContainer data-cy="gallery__info-views">
      <Icon indent={false} IconComponent={ViewsIcon} width={16} height={9} />
      <InfoViewsText tag="caption_1_new">{prettyViews}</InfoViewsText>
    </InfoViewsContainer>
  );
};
